import React, { Component } from 'react';
import Stores from '../components/stores';
import globalizacao from '../escolha/globalizacao';

class About extends Component {

    componentDidMount() {
      //  window.scrollTo(0, 0);
    }


    render() {
        return (
            <section className="secao inner-page sobre fundo-white">
                <div className="limite conteudo">
                    <h2>{globalizacao.msg("about")}</h2>

                    <div dangerouslySetInnerHTML={{
                        __html: globalizacao.msg("aboutTexto")
                    }}>


                    </div>

                    <Stores />
                </div>

            </section>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/js/pages/about.js